import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ProblemSection } from './components/ProblemSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
interface AppProps {
  /** Page palette: dark graphite "arena" look or the warm light "chalk" look. Both use volt-lime buttons. */
  theme?: 'arena' | 'chalk';
}
const THEME_COLORS = {
  arena: '#0c0d0b',
  chalk: '#f5f3ec'
};
export function App({
  theme = 'arena'
}: AppProps) {
  useMetaPixel();
  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'chalk') root.dataset.theme = 'chalk';else delete root.dataset.theme;
    document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme]);
  }, [theme]);
  return <div className="w-full bg-ink font-sans text-fg" data-id="element-0" data-mp="6htjo98ovic">
      <Hero data-id="element-1" data-mp="82jt1oitsae" />
      <main data-id="element-2" data-mp="2zl39tfhhuw2o">
        <TestimonialsSection data-id="element-3" data-mp="2zld2jatxbhc2" />
        <ProblemSection data-id="element-4" data-mp="2zm4xqkjlzd1t" />
        <VolumesSection data-id="element-5" data-mp="2zmwguvw0rib7" />
        <BonusesSection data-id="element-6" data-mp="33mou3lwcycmw" />
        <OfferSection data-id="element-7" data-mp="33m5eibu6k0c1" />
        <GuaranteeSection data-id="element-8" data-mp="33ngee0ki8nxv" />
        <FaqSection data-id="element-9" data-mp="33oriy2lrxzq1" />
        <FinalCtaSection data-id="element-10" data-mp="38lrqkhy9vaj9" />
      </main>
      <Footer data-id="element-11" data-mp="38kqbm2e4y3w9" />
      <StickyCta data-id="element-12" data-mp="38k6ugnwb7jja" />
    </div>;
}